// call.reducer.js
import { callConstants as T } from '../actions/constants';

const initialState = {
    status: 'idle',
    callId: null,
    peerId: null,
    chatId: null,
    mode: 'audio',
    mic: true,
    cam: true,
    incoming: false,
    startedAt: null,
    error: null,
    minimized: false,
    reconnecting: false,
    lastReason: null,
};

export default function callReducer(state = initialState, action) {
    switch (action.type) {
        case T.PATCH_STATE:
            return {
                ...state,
                ...(action.payload || {}),
            };

        case T.INVITE:
            return {
                ...state,
                status: 'dialing',
                callId: action.callId,
                peerId: action.peerId,
                chatId: action.chatId || null,
                mode: action.mode || 'audio',
                incoming: false,
                error: null,
                minimized: false,
                reconnecting: false,
                lastReason: null,
            };

        case T.INCOMING:
            return {
                ...state,
                status: 'ringing',
                callId: action.callId,
                peerId: action.from,
                chatId: action.chatId || null,
                mode: action.mode || 'audio',
                incoming: true,
                error: null,
                minimized: false,
                reconnecting: false,
                lastReason: null,
            };

        case T.CONNECTING:
            return {
                ...state,
                status: 'connecting',
                error: null,
            };

        case T.CONNECTED:
            return {
                ...state,
                status: 'in-call',
                startedAt: Date.now(),
                error: null,
                reconnecting: false,
            };

        case T.TOGGLE_MIC:
            return {
                ...state,
                mic: action.enabled,
            };

        case T.TOGGLE_CAM:
            return {
                ...state,
                cam: action.enabled,
            };

        case T.MINIMIZE:
            return {
                ...state,
                minimized: true,
            };

        case T.RESTORE:
            return {
                ...state,
                minimized: false,
            };

        case T.ENDED:
            return {
                ...initialState,
                lastReason: action.reason || state.lastReason || null,
            };

        case T.ERROR:
            return {
                ...initialState,
                error: action.error,
            };

        default:
            return state;
    }
}